import { DateField, SelectField, TextField } from './Fields';

export const ComponentsMap = {
	DateField,
	TextField,
	SelectField,
};
